import { JSX } from "react";

import Grid from "@mui/material/Grid";

import { Dashboard } from "core/blueprint/dashboard/DashboardTypes";
import WidgetView from "core/widget/WidgetView";
import { Evaluation } from "./TrajectoryService";

export type DashboardViewProps = {
	dashboard: Dashboard;
	evaluation: Evaluation;
	// The day whose state to render; absent means the current state.
	asOf?: Date;
};

export function DashboardView(
	props: Readonly<DashboardViewProps>
): JSX.Element {
	return (
		<Grid container>
			{props.dashboard.widgets.map(widget => (
				<Grid key={widget.uuid} item xs={12}>
					<WidgetView
						widget={widget}
						evaluation={props.evaluation}
						asOf={props.asOf}
					/>
				</Grid>
			))}
		</Grid>
	);
}
